import * as React from 'react';
const SudorazioneDeiPiediIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M85.41 65.65c-3.73 0-8.06-4.09-8.06-9.05s3.6-7.96 8.26-7.96 7.71 2.77 7.71 7.76-2.05 6.92-2.18 7.76-.12 1.4.4 1.78 3.36.89 3.36.89M93.13 52.98c1.05-.85 4.18-2.14 6.22-1.36s3.82 2.64 3.1 4.97c-.72 2.32-2.36 7.18-2.59 8.33-.23 1.16.21 1.84.55 2.31s2.04 1.22 2.04 1.22"
      className="prefix__cls-2"
    />
    <path
      d="M102.25 57.87c.92-.74 3.66-1.87 5.44-1.19s3.34 2.31 2.7 4.34-2.06 6.27-2.26 7.28.18 1.6.48 2.02 1.78 1.07 1.78 1.07"
      className="prefix__cls-2"
    />
    <path
      d="M110.66 61.17c.84-.54 3.09-1 4.52-.27s2.38 2.44 1.79 4.22-1.53 4.04-1.79 4.79-.22 1.04-.15 1.8.75 1.65.75 1.65"
      className="prefix__cls-2"
    />
    <path
      d="M122.72 88.56c.18-1.13.28-2.17.28-3.06 0-6.78-1.02-7.66-1.73-8.67s-.82-2.09-.56-3.26 1.77-2.25 1.61-4.16-1.53-2.59-2.7-2.81-2.89.24-2.89.24M79.78 63.61c0 3.07-2.78 5.43-2.78 13.07 0 15.46 8.62 26.44 8.62 34.25 0 0-2.03 17.36-2.03 25s4.17 15.45 15.45 15.45 16.87-8.05 16.87-14.2c0-3.38.38-8.11.72-12.81"
      className="prefix__cls-2"
    />
    <path
      d="M124.42 108.57c0 3.87-3.25 7.01-7.27 7.01s-7.27-3.14-7.27-7.01c0-1.2.31-2.33.86-3.32l6.41-11.48 6.4 11.48c.55.99.87 2.12.87 3.32M110.63 127.83c0 2.26-1.9 4.08-4.24 4.08s-4.24-1.83-4.24-4.08c0-.7.18-1.36.5-1.93l3.73-6.69 3.73 6.69c.32.58.5 1.23.5 1.93Z"
      className="prefix__cls-1"
    />
  </svg>
);
export default SudorazioneDeiPiediIcon;
